// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RadioGroup, Radio, Text } from 'informed';

import {
  addMiscTest,
  deleteMiscTest,
  updateMiscTest,
} from '../../../actions/testingActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  miscTests: Object[],
  activePatientId: string,
  addMiscTest: Function,
  deleteMiscTest: Function,
  updateMiscTest: Function,
}

class MiscTestsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteMiscTest(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateMiscTest(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addMiscTest(this.props.activePatientId, formData.values);
  }

  render() {
    const { miscTests } = this.props;

    const columns = [
      {
        Header: 'Name',
        id: 'name',
        editCell: item => <Typeahead field='name' initialValue={item.name} endpoint='testName' />,
      },
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
      },
      {
        Header: 'Result',
        id: 'positive',
        cell: item => (
          <div>
            <div>{item.positive || (item.result ? '' : '--')}</div>
            <div>{item.result}</div>
          </div>
        ),
        editCell: item => (
          <div>
            <RadioGroup field='positive' initialValue={item.positive}>
              <Radio value={'Positive'} />Positive<br />
              <Radio value={'Negative'} />Negative<br />
              <Radio value={'Unknown'} />Unknown<br />
            </RadioGroup>
            <Text field='result' initialValue={item.result} placeholder='e.g. 5 mcg/mL (optional)' />
          </div>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        data={miscTests}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  miscTests: state.patient.data.testing.miscTests,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addMiscTest: (patientId, miscTest) => dispatch(addMiscTest(patientId, miscTest)),
  deleteMiscTest: (patientId, miscTestId) => dispatch(deleteMiscTest(patientId, miscTestId)),
  updateMiscTest: (patientId, miscTest) => dispatch(updateMiscTest(patientId, miscTest)),
});

const MiscTests = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MiscTestsComponent);

export default MiscTests;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/MiscTests.jsx